<template>
    <div class="collecte-clients">
      <h2 class="section-title">Collecte de Clients</h2>
      <p class="section-description">
        Visualise les informations collectées par ton agent IA : noms, courriels, numéros de téléphone et plus.
      </p>
  
      <table class="clients-table">
        <thead>
          <tr>
            <th>Nom</th>
            <th>Courriel</th>
            <th>Téléphone</th>
            <th>Date</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="client in clients" :key="client.email">
            <td>{{ client.name }}</td>
            <td>{{ client.email }}</td>
            <td>{{ client.phone }}</td>
            <td>{{ formatDate(client.date) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </template>
  
  <script>
  import Cookies from 'js-cookie'
  
  export default {
    name: 'CollecteClients',
    mounted() {
      const token = Cookies.get('token')
      if (!token) return this.$router.push('/sign-in')
    },
    data() {
      return {
        clients: [
          { name: 'Julie Tremblay', email: 'julie@mail.com', phone: '514-123-4567', date: '2025-04-21' },
          { name: 'Alex Boucher', email: 'alex@mail.com', phone: '438-765-4321', date: '2025-04-20' },
        ]
      }
    },
    methods: {
      formatDate(dateStr) {
        const date = new Date(dateStr);
        return date.toLocaleDateString();
      }
    }
  }
  </script>
  
  <style scoped>
  .collecte-clients {
    padding: 20px;
    background-color: white;
    border-radius: 12px;
    box-shadow: 0 0 12px rgba(0,0,0,0.05);
  }
  .section-title {
    font-size: 1.75rem;
    font-weight: 700;
    margin-bottom: 10px;
  }
  .section-description {
    color: #666;
    margin-bottom: 20px;
  }
  .clients-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 0.95rem;
  }
  .clients-table th,
  .clients-table td {
    border: 1px solid #ddd;
    padding: 12px;
    text-align: left;
  }
  .clients-table th {
    background-color: #f3f4f6;
    font-weight: 600;
  }
  </style>